import { action } from 'typesafe-actions'
import { IFilter, ReportTypes } from './types'
// import { IAxiosResponse, IPaginator, ISearch } from '../root.types'
import { FollowUp } from '../../application/models/followUp/followUp'
import { ActiveSearchSummary } from '../../application/models/report/active.search.summary'
import { ActiveSearchResponse } from '../../application/models/report/active.search.response'
import { Report } from '../../application/models/report/report'


export const loadFollowUpsReport = (followUps: FollowUp[]) =>
    action(
        ReportTypes.LOAD_FOLLOWUP_REPORT, { followUps }
    )

export const reportData = (data: any) =>
    action(
        ReportTypes.REPORT_DATA, { data }
    )

export const loadReportRequest = (filter: IFilter) => action(
    ReportTypes.LOAD_REPORT_REQUEST, { filter }
)
export const loadReportSuccess = (data: Report) => action(
    ReportTypes.LOAD_REPORT_SUCCESS, { data }
)
export const loadReportFailure = () => action(ReportTypes.LOAD_REPORT_FAILURE)

export const loadActiveSearchSummaryRequest = (filter: IFilter) => action(
    ReportTypes.LOAD_ACTIVE_SEARCH_SUMMARY_REQUEST, { filter }
)
export const loadActiveSearchSummarySuccess = (data: ActiveSearchSummary) => action(
    ReportTypes.LOAD_ACTIVE_SEARCH_SUMMARY_SUCCESS, { data }
)
export const loadActiveSearchSummaryFailure = () => action(ReportTypes.LOAD_ACTIVE_SEARCH_SUMMARY_FAILURE)

export const loadActiveSearchResponseRequest = (filter: IFilter) => action(
    ReportTypes.LOAD_ACTIVE_SEARCH_RESPONSE_REQUEST, { filter }
)
export const loadActiveSearchResponseSuccess = (data: ActiveSearchResponse) => action(
    ReportTypes.LOAD_ACTIVE_SEARCH_RESPONSE_SUCCESS, { data }
)
export const loadActiveSearchResponseFailure = () => action(ReportTypes.LOAD_ACTIVE_SEARCH_RESPONSE_FAILURE)


